import BaseAPI from './base'
/**
 * API xử lý giỏ học liệu
 */
class StudentCartAPI extends BaseAPI {}

export default new StudentCartAPI('v1/student-cart', 'StudentCart')
